const EDITING_GROUP_NAMES = ["administrator", "manager"];

/**
 * UX-layer visibility rule for the standby period edit control. The backend guard in
 * ticketService/views.py (user_in_groups_for_unsafe_methods) is the real enforcement;
 * this only decides whether the control is shown, and mirrors that guard exactly.
 *
 * Unlike the time entry and file rules, which exclude technicians and admit everyone
 * else, writes here are an allowlist: administrators and managers only. Coordinators
 * may read standby periods but are refused on write, so they must not see the control.
 */
export function canEditStandbyPeriod(currentUserGroups?: string[]): boolean {
  return (currentUserGroups ?? []).some((group) =>
    EDITING_GROUP_NAMES.includes(group.toLowerCase())
  );
}
